import type { ColorScheme } from "./types";
import { COLOR_VALUES, BG_COLOR_VALUES } from "./constants";

export function getSlideColor(colorScheme: ColorScheme): string {
  return COLOR_VALUES[colorScheme] || "#1967d2";
}

export function getSlideBgColor(colorScheme: ColorScheme): string {
  return BG_COLOR_VALUES[colorScheme] || "#e8f0fe";
}

export function normalizeN8nResponse(raw: any): any {
  if (!raw || !raw.data) return null;

  const apiData = raw.data.apresentacao || raw.data;

  return {
    id: Date.now().toString(),
    title: apiData.titulo || "Apresentação",
    subject: "",
    topic: "",
    audience: "Estudantes",
    slideStyle: "educational",
    colorScheme: "blue" as ColorScheme,
    slideCount: apiData.slides?.length || 0,
    slides: (apiData.slides || []).map((slide: any, index: number) => ({
      id: index + 1,
      title: slide.titulo || `Slide ${index + 1}`,
      content: slide.conteudo || "",
      type: slide.tipo || (index === 0 ? "title" : "content"),
      notes: slide.notas || "",
      estimatedTime: slide.tempo_estimado || 3,
    })),
    structure: apiData.estrutura || [],
    visualResources: apiData.recursos_visuais || [],
    interactiveElements: apiData.elementos_interativos || [],
    presentationTips: apiData.dicas_apresentacao || [],
    createdAt: new Date().toISOString(),
    aiGenerated: true,
  };
}

export function validateFormData(data: any): boolean {
  return !!(data.title && data.subject && data.topic);
}

export function formatSlideContent(content: string | string[]): string[] {
  if (Array.isArray(content)) return content;
  return content.split("\n").filter((line) => line.trim());
}
